module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createdBy":"Created by ©BrightSpaces","portfolio":"Portfolio"},"ro":{"createdBy":"Creat de ©BrightSpaces","portfolio":"Portofoliu"}}')
  delete Component.options._Ctor
}
